import React from "react";
import { SubsrciptionPlanContextProvider } from "./SubsrciptionPlanView";
import SubscriptionPlan from "./views/SubsrciptioPlan";

const SubsrciptionPlanPage = () => {
  return (
    <div>
      <SubsrciptionPlanContextProvider>
        <SubscriptionPlan />
      </SubsrciptionPlanContextProvider>
    </div>
  );
};

export default SubsrciptionPlanPage;
